import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function PurchaseSection() {
  return <section id="purchase-section" className="py-20 text-white bg-[#4C234C]" data-id="element-75">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-76">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#FFFFFF] bg-[#42313100]" data-id="element-77">
          Empezá a cambiar la vida de tu perro hoy mismo
        </h2>

        <p className="text-xl mb-10 max-w-2xl mx-auto text-[#FFFFFF]" data-id="element-78">
          Acceso inmediato a la guía principal "Croquetas o Comida Real" + los 6
          bonos exclusivos de regalo.
        </p>

        <div className="bg-white text-stone-800 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-79">
          <div className="absolute top-0 left-0 w-full bg-emerald-500 text-white text-sm font-bold py-2 uppercase tracking-wider" data-id="element-80">
            Oferta Especial Disponible
          </div>

          <div className="mt-6 mb-8" data-id="element-81">
            <p className="text-stone-500 font-medium mb-2" data-id="element-82">
              Precio de la guía + 6 Bonos gratuitos: A̶n̶t̶e̶s̶ $̶ 4̶9̶.̶9̶9̶0̶
            </p>
            <div className="flex justify-center items-baseline space-x-2" data-id="element-83">
              <span className="text-6xl font-black text-stone-900" data-id="element-84">
                $19,990
              </span>
            </div>
          </div>

          <div className="mb-8" data-id="element-85">
            <CTAButton text="SÍ, QUIERO LA GUÍA AHORA" href="https://pagos.comidarealparatuperro.shop/checkouts/cn/hWN9ltH9CJJBhJyeBJKxVgn4/es-ar?_r=AQABKLS3XvOX9CmRbxvqK2CylEWEq6Wr1sr76CLUFcbhRoU&cart_link_id=Wt06iqyF&preview_theme_id=150983245980" className="w-full text-xl md:text-2xl py-5" data-id="element-86" />
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 text-sm text-stone-500 font-medium" data-id="element-87">
            <div className="flex items-center" data-id="element-88">
              <ShieldCheck className="w-5 h-5 text-emerald-500 mr-2" data-id="element-89" />
              Garantía de Satisfacción
            </div>
            <div className="flex items-center" data-id="element-90">
              <Lock className="w-5 h-5 text-emerald-500 mr-2" data-id="element-91" />
              Pago 100% Seguro
            </div>
            <div className="flex items-center" data-id="element-92">
              <CreditCard className="w-5 h-5 text-emerald-500 mr-2" data-id="element-93" />
              Acceso Inmediato
            </div>
          </div>

          {/* MEDIOS DE PAGO */}
          <div className="mt-10 border-t border-stone-200 pt-8" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/fmr6LBTaTEs6x9eUBpvWFu/Mercado_Pago.jpg" alt="Medios de Pago - Mercado Pago" className="w-full max-w-md mx-auto rounded-lg" data-id="element-95" />
          </div>

          {/* GARANTÍA Y COMPRA SEGURA */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/bLNBduuCUnDSnm4MKEvSc4/garantia_7_dias.png" alt="Garantía 7 Días" className="w-28 md:w-36 object-contain" data-id="element-97" />
            <img src="https://cdn.magicpatterns.com/uploads/jQX9sToicTj4sbJZrLMReB/compra_asegurada.png" alt="Compra Segura" className="w-40 md:w-52 object-contain" data-id="element-98" />
          </div>
        </div>
      </div>
    </section>;
}